
export enum AuctionListingSnapshotWsEventResponseDtoEvent {
  AuctionListingSnapshot= 'AuctionListingSnapshot',

}